import { priceFormat } from '@/utils/utils';

/**
 * 在 setup 中绑定 `useUserInfo()`（SSR payload + 水合后与 localStorage 对齐），
 * 返回与之一致的 `formatPrice`，避免在 `priceFormat` 内读 `localStorage` 导致水合不一致。
 */
export function usePriceFormat() {
	const userInfo = useUserInfo();

	function formatPrice(
		productPrice: string | number,
		fixNum?: number,
		isControlSales?: number | string,
		isSeeNoBuy?: number | string
	): string | number {
		return priceFormat(productPrice, userInfo.value, fixNum, isControlSales, isSeeNoBuy);
	}

	return { formatPrice, userInfo };
}
